import { env } from './EnvironmentConfig';

export const APP_NAME = 'Oumuamua';
//REACT_APP_DEV_MODE values - "Dev" or "Live" or "userDev"
export const REACT_APP_DEV_MODE = process.env.REACT_APP_MODE;

export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = '';
export const APP_IN_PRODUCTION = process.env.NODE_ENV === 'production';


export const TEST_URL = "https://design.24liveyard.com/";
export const TEST_USER_URL = "https://uatfrontendnews.24liveyard.com/";
export const LIVE_URL = "https://oumuamua.news/";
export const DONATE_LINK = "https://oumuamua.networkforgood.com/projects/233397-everyday-giving"
